import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetSR_TypeList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'SR_Type/GetAllSR_TypeList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewSR_Type = async (SR_TypeDet) => {
    //debugger;
    //console.log(JSON.stringify(SR_TypeDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `SR_Type/CreateNewSR_Type`, 
        JSON.stringify(SR_TypeDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateSR_Type = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `SR_Type/ActivateDeActivateSR_Type?SR_TypeId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateSR_Type = async(SR_TypeDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'SR_Type/UpdateSR_Type', 
        JSON.stringify(SR_TypeDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}